import { createAppBadge, node } from "~/util/dom";
import { getMobileOperatingSystem } from "~/util/userweb";
import { getMobilePromoLink } from "~/util/mobile-promo";
import { CONFIG } from "~/config";

export default function createMobileAppButtons(check = true): HTMLUListElement {
	const OSList: Array<{
		name: string;
		log: "android" | "iOS",
		check: Array<string>;
		link: string;
	}> = [{
		name: "android",
		log: "android",
		check: ["", "wp", "a"],
		link: getMobilePromoLink(CONFIG.android),
	},
	{
		name: "ios",
		log: "iOS",
		check: ["", "wp", "i"],
		link: getMobilePromoLink(CONFIG.ios),
	}];

	const apps = node("ul", { className: "mobile-apps" });
	const os = check ? getMobileOperatingSystem() : "";

	OSList.forEach(osItem => {
		if (osItem.check.indexOf(os) > -1) {
			const item = node("li", {
				className: osItem.name,
			});

			item.appendChild(createAppBadge(osItem.log, CONFIG.defaultLang, osItem.link));
			apps.appendChild(item);
		}
	});

	return apps;
}
